//#region Utils
import { getOptionsToCustomSelect } from "components/CustomSelect/utils";
import { handlerKeyPressOnlyNumbers } from "utils/validations";
import { 
    PENALTY_DETAILS_MAX_LENGTH,
    STYLE_PROPS_CUSTOM_SELECT, 
} from "./utils/constants";
import { Column, Row } from "components/styles";
import { Fields } from "./styles";
import CustomSelect from "components/CustomSelect/CustomSelect";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import CustomTextArea from "components/CustomTextArea/CustomTextArea";
//#endregion

const PenalizeForm = ({
    isUpdate, subtitle,
    form, data: {
        reasonsForPenalize
    }, 
}) => {
    const {
        reasonForPenalizeId, penalizeDays, details
    } = form.value;
    return (
        <Column>
            <p className="paragraph center">{subtitle}</p>
            <Fields className="custom-scrollbar primary">
                <Row justifyContent="flex-start">
                    <CustomSelect
                        label="Motivo"
                        value={reasonForPenalizeId}
                        onChange={form.setReasonForPenalizeId}
                        defaultOptionText="Elige un Motivo"
                        {...STYLE_PROPS_CUSTOM_SELECT}
                        optionsProps={getOptionsToCustomSelect(reasonsForPenalize, { id: "id", text: "name" })}
                        disabled={isUpdate}/>
                    <CustomTextInput
                        label="Días de sanción"
                        placeholder="Días"
                        value={penalizeDays}
                        minWidth="170px"
                        width="170px"
                        maxLength={3}
                        onKeyPress={handlerKeyPressOnlyNumbers}
                        onChange={form.setPenalizeDays}/>
                </Row>
                <CustomTextArea
                    label="Detalles"
                    placeholder="Describe el motivo de la sanción"
                    value={details}
                    onChange={form.setDetails}
                    showCharCounter={false}
                    maxLength={PENALTY_DETAILS_MAX_LENGTH}
                    height="50px"/>
            </Fields>
        </Column>
    );
}

export default PenalizeForm;